import React, { useEffect, useState, SyntheticEvent } from 'react'
import Link from 'next/link'
import { Image } from 'Components/view-image'
import dayjs from 'dayjs'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export interface CheyouCommunityInfo {
  motor_id?: string //车友圈motorId
  title_icon?: string // icon
  title_name?: string //资讯名称
}
export interface GetNewCarReleaseResponse {
  data: NewCarReleaseData
  message: string
  prompts: string
  status: number
}
export interface NewCarArticleInfo {
  gid?: string //先用gid作为参数，待确定
  title_icon?: string // icon
  title_name?: string //资讯名称
}
export interface NewCarReleaseData {
  category_tab?: NewCarTab[] // 新车类别分类
  count?: number // 当前返回的个数
  current_time?: number // 服务器返回时间戳
  has_more?: boolean // 是否还有数据
  month_tab?: NewCarTab[] //月份分类，即将上市是-1
  series_list?: NewCarSeriesInfo[] // 新车车系信息
  total_count?: number // 总数
}
export interface NewCarSeriesInfo {
  article_info?: NewCarArticleInfo //新车资讯
  brand_id?: number //品牌id
  cover_url?: string // 图片
  brand_name?: string //品牌名称
  cheyou_community_info?: CheyouCommunityInfo //车友圈信息
  id?: number //id
  online_date_day?: number //上线天
  online_date_month?: number // 上线月份
  online_date_unix?: number //上线时间戳
  price_info?: PriceInfo //价格信息
  series_id?: number //车系id
  series_name?: string // 车系名称
  tag_list?: NewCarTagList[] //新车标签信息--已上市的才有
  isOnlining?: boolean // 前端添加的 是否为新车
  series_new_energy_type: number
  series_type: number
}
export interface NewCarTab {
  name?: string // tab 名称
  value?: string //tab值
}
export interface NewCarTagList {
  name?: string // tag 名称
}
export interface PriceInfo {
  bg_color?: string //背景颜色
  city_name?: string //城市名
  color?: string //数字颜色
  price?: string // 数字主体 1.23
  price_prefix?: string // 价格前缀, "官方指导价: "
  price_suffix?: string //价格后缀
  text?: string //价格其他描述文案
  unit_text?: string //价格单位, 元/万元/万起
}

const MAX_FRAME_TIMES = 5

export const getNewCarData = async (req: any) => {
  const url = getUrl(
    '/motor/pc/car/new_car_release?month=-1&source=1',
    'motor.pc_car.api'
  )
  const json: GetNewCarReleaseResponse = await fetch(url, {
    req,
  }).catch((err) => {
    console.error('[fetch] newCarData error', err)
    return []
  })
  const data = json?.data || {}
  // eslint-disable-next-line no-unused-expressions
  data?.series_list?.forEach((item: NewCarSeriesInfo) => {
    try {
      // 转为天数 大于等于今天的，算是即将上市
      if (
        item?.online_date_unix &&
        data?.current_time &&
        dayjs(item?.online_date_unix * 1000).format('YYYYMMDD') >=
          dayjs(data?.current_time * 1000).format('YYYYMMDD')
      ) {
        item.isOnlining = true
      }
    } catch (error) {
      console.error('newhome_choosecar_判断是否上市判断失败', error)
      return []
    }
  })
  return data?.series_list || []
}

interface IProps {
  newCarData: NewCarSeriesInfo[]
}

export default function NewCar({ newCarData = [] }: IProps) {
  const [carList, setCarList] = useState<any[]>([])

  useEffect(() => {
    async function init() {
      const data = await getNewCarData(null)
      setCarList(data)
    }
    // 服务器请求改接口常超时 浏览器端重试
    if (!newCarData?.length) {
      init()
    }
  }, [newCarData])

  return (
    <>
      <div className="new-car">
        <Link href={'/newcar'} as={'/newcar'}>
          <a
            className="new-car-title g-active-link-text tw-mt-51 xl:tw-mt-35"
            target="_blank"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'recent_car_module_title',
                module_title: '重磅新车',
                module_id: 'recent_car_module',
              })
            }}
          >
            近期重磅新车
          </a>
        </Link>
        <ul className="new-car-list">
          {newCarData?.length || carList?.length
            ? renderCarList(newCarData?.length ? newCarData : carList)
            : renderBgList()}
        </ul>
        <style jsx>
          {`
            .new-car-list {
              margin-left: -16px;
              margin-right: -16px;
              padding-left: 16px;
              padding-right: 16px;
              overflow-y: scroll;
              height: 322px;
              overscroll-behavior: none;
            }
            .new-car {
              position: relative;
            }
            .new-car:after {
              content: '';
              position: absolute;
              bottom: -2px;
              left: 0;
              right: 0;
              height: 40px;
              background-image: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0),
                #f2f4fa
              );
            }
            .new-car-list::-webkit-scrollbar {
              width: 5px;
              background: transparent;
            }
            .new-car-list::-webkit-scrollbar-track {
              width: 5px;
              background: transparent;
            }
            .new-car-list:hover::-webkit-scrollbar-thumb {
              width: 5px;
              height: 30px;
              width: 5px;
              border-radius: 3.5px;
              background-color: #d8d8d8;
            }
            .new-car-title {
              display: block;
              font-size: 20px;
              font-weight: 600;
              color: #1f2129;
              height: 28px;
              margin-bottom: 16px;
            }
          `}
        </style>
      </div>
    </>
  )
}

function renderCarList(carData: any) {
  return (
    <>
      {carData?.length
        ? carData?.map((item: NewCarSeriesInfo, index: number) => {
          return (
            <li
              key={`${index}-${item.id}`}
              className={classnames({
                'new-car-item': true,
                online: !item?.isOnlining,
              })}
            >
              <Link
                href={`/auto/series?seriesId=${item.series_id}`}
                as={`/auto/series/${item.series_id}`}
              >
                <a
                  target="_blank"
                  className="item-time-link"
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: 'recent_car_module_series_cell',
                      car_series_id: `${item.series_id}`,
                      car_series_name: item.series_name,
                      module_id: 'recent_car_module',
                    })
                  }}
                >
                  <div className="item-time-fix-wrap">
                    <p className="item-time-wrap">
                      <span className="item-time">
                        {item?.online_date_unix
                          ? dayjs(item?.online_date_unix * 1000).format(
                            'YYYY.M.D'
                          )
                          : ''}
                      </span>
                      <span className="item-time-status">
                        {item?.isOnlining ? '发布' : '已上市'}
                      </span>
                    </p>
                    {!item?.isOnlining &&
                      item?.tag_list?.length &&
                      item?.tag_list?.[0]?.['name'] ? (
                        <p className="item-tag">
                          {item?.tag_list?.[0]?.['name']}
                        </p>
                      ) : (
                        ''
                      )}
                    <p
                      className={`
                      item-title-wrap
                      sm:tw-mr-75
                      md:tw-mr-150
                      `}
                    >
                      <span
                        className={classnames(
                          'item-title g-active-link-text g-one-line-text',
                          {
                            hastag:
                                !item?.isOnlining && item?.tag_list?.length,
                          }
                        )}
                      >
                        {item.series_name}
                      </span>
                    </p>
                    <p
                      className={classnames({
                        'item-price': true,
                        'no-price':
                            item?.price_info?.price?.indexOf('暂无报价') === 0,
                      })}
                    >
                      {item?.price_info?.price}
                      {item?.price_info?.unit_text}
                    </p>
                  </div>
                  {item?.cover_url && (
                    <p
                      className={`
                    car-image-wrap
                    tw-right-0
                    tw-top-0
                    tw--right-73
                    sm:tw--right-73
                    md:tw-right-0
                    car-image-type-${
                      item?.series_new_energy_type > 0 ? 'ev' : item.series_type
                    }
                    `}
                    >
                      <Image
                        className={`
                        homepage-new-car-img
                        tw-right-5
                        tw-top-19
                        md:tw-right-2
                        lg:tw-right-8
                      `}
                        width={304}
                        height={210}
                        alt={item?.brand_name}
                        src={item?.cover_url}
                      />
                    </p>
                  )}
                </a>
              </Link>
              {item?.cheyou_community_info?.title_name && (
                <Link
                  href={`/community?series_id=${item?.cheyou_community_info?.motor_id}`}
                  as={`/community/${item?.cheyou_community_info?.motor_id}`}
                >
                  <a
                    className="item-community item-one-line-text"
                    target="_blank"
                    onClick={() => {
                      sendTeaCommEvent('clk_event', {
                        event_id: 'recent_car_module_motor',
                        car_series_id: `${item.series_id}`,
                        car_series_name: item.series_name,
                        motor_id: item?.cheyou_community_info?.motor_id,
                        motor_name: `${item.series_name}车友圈`,
                        module_id: 'recent_car_module',
                      })
                    }}
                  >
                    <span className="max-width item-one-line-text">
                      {item?.cheyou_community_info?.title_name}
                    </span>
                    <span className="more" />
                  </a>
                </Link>
              )}

              {item?.article_info?.title_name && (
                <Link
                  href={`/article?gid=${item?.article_info?.gid}`}
                  as={`/article/${item?.article_info?.gid}`}
                >
                  <a
                    className="item-article"
                    target="_blank"
                    onClick={() => {
                      sendTeaCommEvent('clk_event', {
                        event_id: 'recent_car_module_news',
                        car_series_id: `${item.series_id}`,
                        car_series_name: item.series_name,
                        group_id: item?.article_info?.gid,
                        module_id: 'recent_car_module',
                      })
                    }}
                  >
                    <span className="max-width item-one-line-text">
                      {item?.article_info?.title_name}
                    </span>
                    <span className="more" />
                  </a>
                </Link>
              )}
            </li>
          )
        })
        : ''}
      <style jsx>
        {`
          .item-time-fix-wrap {
            position: absolute;
            top: 16px;
            left: 16px;
            right: 0;
            z-index: 9;
          }
          .car-image-wrap {
            position: absolute;
            width: 152px;
            height: 105px;
            background-image: url(${require('./static/default.png')});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100%;
          }

          .car-image-type-0 {
            background-image: url(${require('./static/0.png')});
          }
          .car-image-type-1 {
            background-image: url(${require('./static/1.png')});
          }
          .car-image-type-2 {
            background-image: url(${require('./static/2.png')});
          }
          .car-image-type-3 {
            background-image: url(${require('./static/3.png')});
          }
          .car-image-type-4 {
            background-image: url(${require('./static/4.png')});
          }
          .car-image-type-6 {
            background-image: url(${require('./static/6.png')});
          }
          .car-image-type-7 {
            background-image: url(${require('./static/7.png')});
          }
          .car-image-type-8 {
            background-image: url(${require('./static/8.png')});
          }
          .car-image-type-ev {
            background-image: url(${require('./static/ev.png')});
          }

          .new-car-item {
            position: relative;
            max-height: 168px;
            font-size: 12px;
            background: #fff;
            border-radius: 4px;
            color: #1f2129;
            margin-bottom: 8px;
            padding-bottom: 8px;
            transition: all ease-in-out 0.1s;
            overflow: hidden;
          }
          .new-car-item:hover {
            box-shadow: 0 8px 16px 0 rgba(31, 33, 41, 0.12);
          }
          .item-time-wrap {
            display: inline-block;
            height: 19px;
            padding: 1px 4px;
            border-radius: 2px;
            background-color: #f2f4fa;
            font-size: 12px;
            font-weight: 600;
            color: #1f2129;
          }
          .online .item-time-wrap {
            background-color: #1f2129;
            color: #f7f8fc;
          }
          .item-tag {
            display: inline-block;
            margin-left: 2px;
            height: 19px;
            padding: 1px 4px;
            border-radius: 2px;
            background-color: #00a860;
            font-size: 12px;
            font-weight: 600;
            color: #ffffff;
          }
          .item-time-link {
            height: 106px;
            padding: 36px 16px 0 16px;
            display: block;
            transition: 0.5s;
            position: relative;
          }
          .item-time-link:before {
            content: '';
            height: 1px;
            background: #e6e8f2;
            position: absolute;
            left: 16px;
            right: 16px;
            bottom: 0;
            z-index: 9;
          }
          .itme-time-icon {
            display: inline-block;
            width: 14px;
            height: 14px;
            background-image: url(${require('static/time.png')});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100%;
            vertical-align: -2px;
            margin-right: 4px;
          }
          .item-time-link:hover {
            color: #1f2129 !important;
          }
          .item-time-status {
            padding-left: 4px;
          }
          .item-time-status:before {
            content: '.';
            display: inline-block;
            position: absolute;
            margin-left: -4px;
            margin-top: -3px;
          }

          .item-title-wrap {
            margin-top: 8px;
            margin-left: 0;
            margin-bottom: 2px;
            font-size: 16px;
            font-weight: 600;
            color: #1f2129;
            position: relative;
          }
          .item-title {
            max-width: 100%;
            display: inline-block;
            vertical-align: middle;
          }
          .item-title.hastag {
            max-width: 100%;
          }
          .item-title-wrap .tag {
            text-align: center;
            padding: 2px 4px;
            border-radius: 2px;
            display: inline-block;
            background: rgba(230, 88, 0, 0.1);
            font-size: 12px;
            color: #b37d12;
            transform: scale(0.8);
            vertical-align: middle;
            margin: 0;
            top: 3px;
            position: absolute;
            margin-left: -3px;
          }
          .tag-width-1 {
            width: 35px;
          }
          .tag-width-2 {
            width: 40px;
          }
          .tag-width-3 {
            width: 45px;
          }
          .tag-max-width {
            width: 60px;
          }
          .item-price {
            padding: 0 0 8px 0;
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: 600;
            color: #e62021;
          }
          .no-price {
            color: #979aa8 !important;
          }
          :global(.new-car-item .homepage-new-car-img) {
            position: absolute;
            width: 126px;
            height: 84px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: 100% 0;
          }
          .item-one-line-text {
            margin: 2px 2px 0 0;
            font-size: 12px;
            color: #979aa8;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
            display: block;
          }
          .item-community {
            padding-left: 16px;
            height: 24px;
            position: relative;
            padding-top: 4px;
            padding-bottom: 4px;
            padding-right: 8px;
            cursor: pointer;
          }
          .item-article {
            position: relative;
            padding-left: 16px;
            padding-right: 8px;
            cursor: pointer;
          }
          .max-width {
            max-width: calc(100% - 39px);
            display: inline-block;
          }
          .more {
            display: inline-block;
            content: '';
            width: 0;
            height: 0;
            display: inline-block;
            margin-left: 4px;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #979aa8;
            vertical-align: super;
          }
          .item-article:hover span,
          .item-community:hover span {
            color: #1f2129;
            transition: 0.5s;
          }
          .item-article:hover .more,
          .item-community:hover .more {
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #1f2129;
          }
        `}
      </style>
    </>
  )
}

function renderBgList() {
  return (
    <>
      {[0, 1].map((item: number, index: number) => {
        return (
          <li key={`${index}-bg`} className="g-load-img-wrap new-car-item" />
        )
      })}
      <style jsx>
        {`
          .new-car-item {
            position: relative;
            height: 152px;
            padding: 8px 16px;
            border-radius: 4px;
            margin-bottom: 8px;
          }
        `}
      </style>
    </>
  )
}
